var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "popup", class: { visible: _vm.showPopup } },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "wrapper", style: { marginTop: _vm.offsetTop } },
          [
            _c("div", { staticClass: "header" }, [
              _c("div", {
                staticClass: "close",
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              }),
              _vm._v(" "),
              _vm.installUrl
                ? _c("div", { staticClass: "header-title text-center" }, [
                    _vm._v("\n          Premium Version unlocked\n        ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.installUrl
                ? _c("div", { staticClass: "header-title" }, [
                    _c("p", [_vm._v("Total today:")]),
                    _vm._v(" "),
                    _c("p", [_vm._v("$0.00")])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            !_vm.installUrl
              ? _c("div", { staticClass: "form-wrapper" }, [
                  _vm.$parent.apple_pay_available
                    ? _c("div", { staticClass: "apple-button-wrapper" }, [
                        _c(
                          "button",
                          {
                            staticClass: "apple-button",
                            class: { loading: _vm.loading },
                            on: {
                              click: function($event) {
                                return _vm.$parent.payWithApplePay()
                              }
                            }
                          },
                          [
                            _vm._v("Continue with "),
                            _c("span", { staticClass: "apple" }, [
                              _vm._v("Pay")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "or" }, [_vm._v("or")])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("form", { attrs: { id: "card-pay-form" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.email,
                          expression: "user.email"
                        }
                      ],
                      staticClass: "email",
                      attrs: {
                        name: "email",
                        type: "email",
                        required: "",
                        placeholder: "Email address"
                      },
                      domProps: { value: _vm.user.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.user, "email", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { attrs: { id: "stripe-card-form" } }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        class: { loading: _vm.loading },
                        attrs: { type: "submit" }
                      },
                      [_vm._v("TRY FOR FREE")]
                    ),
                    _vm._v(" "),
                    _vm.error
                      ? _c("p", { staticClass: "error" }, [
                          _vm._v(
                            "Subscription failed, please review form or try again later."
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "note" }, [
                      _vm._v(
                        "\n          *By continuing you agree that if you don't cancel at least 24 hours prior to the end of the " +
                          _vm._s(_vm.$parent.trial_days) +
                          "-days trial, you will automatically be charged $ " +
                          _vm._s(_vm.$parent.price) +
                          " / " +
                          _vm._s(_vm.$parent.interval) +
                          " auto-renewable due to subscription plan chosen above every mentioned plan's period until you cancel it.\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "note" }, [
                      _vm._v(
                        "If you have any questions please contacts us at " +
                          _vm._s(_vm.support_email)
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.installUrl
              ? _c("div", { staticClass: "form-wrapper" }, [
                  _c("p", [
                    _vm._v("Use link below to download  from App Store")
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "install-link",
                      attrs: { href: _vm.installUrl }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            "/media/pulse-new/email/download-on-appstore.svg",
                          alt: "AppStore link"
                        }
                      })
                    ]
                  )
                ])
              : _vm._e()
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }